module.exports = __webpack_public_path__ + "static/media/icon_file_elf.bb59d036.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_elf.svg
// module id = 155
// module chunks = 0